/**
 * Paleta dos gráficos do painel.
 *
 * As cores ficam aqui, em hexadecimal, e não como variáveis CSS, porque são
 * aplicadas em ATRIBUTOS do SVG (`stroke`, `fill`) — e atributo de apresentação
 * não entende `var(...)`.
 *
 * A ordem das séries NÃO é decorativa: ela foi validada para daltonismo
 * (deuteranopia/protanopia/tritanopia) sobre a SUPERFÍCIE ESCURA do app
 * (#12151f — tema gamer; pior par vizinho ΔE 9.4 deutan, contraste ≥ 3:1),
 * com separação mínima entre pares vizinhos. Trocar a ordem ou inserir uma
 * cor no meio quebra essa garantia — se precisar de uma quarta série, prefira
 * separar em dois gráficos. Se a superfície mudar, revalide as cores.
 *
 * A cor da marca nunca vai para o TEXTO: rótulos, valores e legendas usam os
 * tons de tinta do app, e a identidade vem do ponto colorido ao lado.
 */

/** Cores das séries categóricas, na ordem de uso. */
export const SERIES_COLORS = ['#3987e5', '#d95926', '#199e70'] as const;

/**
 * Cores de ESTADO — reservadas para status HTTP e saúde.
 *
 * Nunca são usadas como "mais uma série": verde/amarelo/vermelho já carregam
 * significado, e reaproveitá-los para categorias faria o painel mentir. Elas
 * sempre aparecem acompanhadas do rótulo, nunca só pela cor.
 */
export const STATUS_COLORS = {
  good: '#0ca30c',
  warning: '#fab219',
  critical: '#d03b3b',
} as const;
